// extracted by mini-css-extract-plugin
module.exports = {"media":"videoPlayer_media__3KhKD"};